import { useIsAuth } from 'feature/auth/hooks'
import { useGetUserQuery } from 'feature/user/redux/user.api'
import { ChangeEvent, useEffect, useState } from 'react'
import { useActions } from 'store/hooks'

import { useStepUserForm } from './useStepUserForm'

type FieldState = {
  isValid: boolean
  isError: boolean
  value: string
  disabled?: boolean
}

// логика формы личных данных по заявке (email + телефон получателя)
export const useUserDataForm = () => {
  const isAuth = useIsAuth()
  const { rawEmail, rawPhone, validateEmail, validatePhone } = useStepUserForm()
  const { setEmailOrder, setPhoneOrder } = useActions()
  const { data: userData, isLoading } = useGetUserQuery(undefined, {
    skip: !isAuth,
  })

  const [email, setEmail] = useState<FieldState>({
    isValid: validateEmail(rawEmail),
    isError: false,
    value: rawEmail,
    disabled: false,
  })
  const [phone, setPhone] = useState<FieldState>({
    isValid: validatePhone(rawPhone),
    isError: false,
    value: rawPhone,
  })

  // авто-заполнение email из профиля авторизованного пользователя
  useEffect(() => {
    if (!userData?.email) return

    setEmail({
      isValid: true,
      isError: false,
      value: userData.email,
      disabled: true,
    })
    setEmailOrder(userData.email)
  }, [userData])

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setEmail(prev => ({
      isValid: validateEmail(value),
      isError: prev.isError,
      value,
      disabled: false,
    }))
    setEmailOrder(value)
  }

  const setEmailValue = (value: string) => {
    setEmail(prev => ({
      isValid: validateEmail(value),
      isError: prev.isError,
      value,
      disabled: false,
    }))
    setEmailOrder(value)
  }

  const handleEmailBlur = () => {
    setEmail(prev => ({
      ...prev,
      isError: !prev.isValid,
    }))
  }

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setPhone(prev => ({
      isValid: validatePhone(value),
      isError: prev.isError,
      value,
    }))
    setPhoneOrder(value)
  }

  const setPhoneValue = (value: string) => {
    setPhone(prev => ({
      isValid: validatePhone(value),
      isError: prev.isError,
      value,
    }))
    setPhoneOrder(value)
  }

  const handlePhoneBlur = () => {
    setPhone(prev => ({
      ...prev,
      isError: !prev.isValid,
    }))
  }

  return {
    isLoading,
    email,
    phone,
    isValid: email.isValid && phone.isValid,
    handleEmailChange,
    handleEmailBlur,
    handlePhoneChange,
    handlePhoneBlur,
    setEmailValue,
    setPhoneValue,
  }
}
